<script>
// Stripe dashboard style status badge (tasks#97): the one display chip of the admin.
// Controls (filter chips, input selections, buttons) stay Vuetify chips.
export const STATUS_BADGE_TONES = [
    'neutral',
    'info',
    'success',
    'attention',
    'critical',
]

export default {
    name: 'StatusBadge',
    props: {
        tone: {
            type: String,
            default: 'neutral',
            validator: (value) => STATUS_BADGE_TONES.includes(value),
        },
        href: {
            type: String,
            default: undefined,
        },
        target: {
            type: String,
            default: undefined,
        },
        rel: {
            type: String,
            default: undefined,
        },
        to: {
            type: [String, Object],
            default: undefined,
        },
        // long texts wrap instead of overflowing; the height follows the content
        wrap: Boolean,
    },
    render(h) {
        const data = {
            class: [
                'status-badge',
                `status-badge--${this.tone}`,
                { 'status-badge--wrap': this.wrap },
            ],
            attrs: {
                target: this.target,
                rel: this.rel,
            },
        }
        // class, style and the other attributes ($attrs) reach the root element by Vue's
        // attribute inheritance; listeners are forwarded here
        if (this.to) {
            // router-link is a component: listeners go on its <a> as native ones, the same
            // way Vuetify's routable mixin does it
            data.props = { to: this.to }
            data.nativeOn = this.$listeners
            return h('router-link', data, this.$slots.default)
        }
        data.on = this.$listeners
        if (this.href) {
            data.attrs.href = this.href
            return h('a', data, this.$slots.default)
        }
        return h('span', data, this.$slots.default)
    },
}
</script>

<style lang="scss">
// text / background (DoorDash tags, tasks#211: neutral, informational, positive = Ordit brand,
// warning, negative)
$status-badge-tones: (
    neutral: (
        #191919,
        #f1f1f1,
    ),
    info: (
        #00666d,
        #ecfcfc,
    ),
    success: (
        #197d19,
        #e7fbef,
    ),
    attention: (
        #191919,
        #fff6d4,
    ),
    critical: (
        #b71000,
        #fff0ed,
    ),
);

.status-badge {
    display: inline-flex;
    align-items: center;
    min-height: 20px;
    padding: 1px 4px;
    border-radius: 4px;
    font-family: inherit;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: -0.01px;
    white-space: nowrap;
    text-decoration: none;

    &--wrap {
        min-width: 0;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    // doubled class: stronger than Vuetify's `.v-application a { color }` on linked badges
    @each $tone, $colors in $status-badge-tones {
        &.status-badge--#{$tone} {
            color: nth($colors, 1);
            background-color: nth($colors, 2);
        }
    }

    &:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 1px;
    }

    // icons and icon buttons in the slot take the tone colour
    .v-icon.v-icon {
        color: inherit;
    }
}
</style>
